import Helpers from '../inc/Helpers';
import Ajax    from '../inc/Ajax';

class Reviews {
    constructor()  {
        this.helpers = new Helpers();
        this.ajax = new Ajax();

        this.photographID = $('body').data('photograph-id') ?? false;
        this.theModal = $('#modal-review');
        this.ajaxOverlay = this.theModal.find('.ajax-overlay');
        this.modalTitle = this.theModal.find('.modal-title');
        this.theForm = this.theModal.find('form');
        this.reviewTypeField = this.theForm.find('[name="review_type"]');
        this.photographIDField = this.theForm.find('[name="photograph_id"]');
    }

    init() {
        let self = this;

        self.handleModal();
        self.chooseNote();
        self.submit();
        self.scrollToTheBlock();
    }

    handleModal() {
        let self = this;

        let triggerBtns = $('.add-review');
        let visibleTriggerBtn = $('.add-review:visible').eq(0);

        switch (sarypak.PHPToJS.currentPage) {
            case 'homepage':
            case 'search-results':
                self.modalTitle.html('Donnez votre avis sur ce site');
                self.reviewTypeField.val('site');
                break;

            case 'portfolio':
                self.modalTitle.html('Donnez votre avis sur ce professionnel');
                self.reviewTypeField.val('photograph');
                self.photographIDField.val(this.photographID);
                break;
        }

        triggerBtns.on('click', function (e) {
            e.preventDefault();

            let thisBtn = $(this);
            let btnHref = thisBtn.attr('href');

            if (btnHref !== '#') {
                window.location.href = btnHref;
                return;
            }
            
            self.theModal.modal('show');
        });

        if (window.location.hash === '#deposer-avis') {
            visibleTriggerBtn.trigger('click');
        }
    }

    chooseNote() {
        $('#stars li').on('mouseover', function () {
            let onStar = parseInt($(this).data('value'), 10);

            $(this).parent().children('li.star').each(function (e) {
                if (e < onStar) {
                    $(this).addClass('hover');
                }
                else {
                    $(this).removeClass('hover');
                }
            });

        }).on('mouseout', function () {
            $(this).parent().children('li.star').each(function (e) {
                $(this).removeClass('hover');
            });
        });

        $('#stars li').on('click', function () {
            let onStar = parseInt($(this).data('value'), 10);
            let stars = $(this).parent().children('li.star');

            for (let i = 0; i < stars.length; i++) {
                $(stars[i]).removeClass('selected');
            }

            for (let i = 0; i < onStar; i++) {
                $(stars[i]).addClass('selected');
            }

            let ratingValue = parseInt($('#stars li.selected').last().data('value'), 10);

            $('.review-rating-value').val(ratingValue);
            $('#review-rating-submit').removeAttr('disabled');
            $('#review-rating-submit').removeClass('disabled');
        });
    }

    submit() {
        let self = this;

        let triggerButton = $('#modal-review .modal-footer .submit');

        triggerButton.on('click', function () {
            self.theForm.trigger('submit');
        });

        self.theForm.on('submit', function (e) {
            e.preventDefault();

            let thisForm = $(this);

            let data = thisForm.serializeArray();

            const done = function () {
                window.location.reload();
            };

            const fail = function (response) {
                self.helpers.formErrors(thisForm, response.responseJSON.errors);
                self.ajaxOverlay.fadeOut(150);
            };

            const always = function () {};

            thisForm.find('.error').empty();
            self.ajaxOverlay.fadeIn(150);

            self.ajax.post('/api/reviews/add-new', 'JSON', data, done, fail, always);
        });
    }

    scrollToTheBlock() {
        let reviewsBlock = $('.reviews-block:visible');

        if (reviewsBlock.length === 0) {
            return;
        }

        if (window.location.hash === '#avis') {
            let blockTopOffset = reviewsBlock.eq(0)
                                             .offset()
                                             .top
            ;

            $('html, body').animate({
                scrollTop: blockTopOffset
            }, 400);
        } 
    }
}

export default Reviews;